import { Component } from '@verndale/core';
import { KEYS, KEYS_DIRECTION } from '../constants';
import _debounce from 'lodash.debounce'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $triggers: this.el._$$('[aria-expanded]'),
      $panels: this.el._$$('.accordion-item__panel')
    };

    this.resetFocusability();
    this.checkIfOpen();
  }

  addListeners() {
    this.dom.$triggers._on('click', this.handleClick.bind(this));
    this.dom.$triggers._on('keydown', this.handleKeyDown.bind(this));
    this.dom.$triggers._on('keyup', this.handleKeyUp.bind(this));
    this.el._on('expandAll', this.handleExpandAll.bind(this));
    this.el._on('collapseAll', this.handleCollapseAll.bind(this));
    window._on('resize', _debounce(this.updateMinHeights.bind(this), 200));

    this.initialized = true;
  }

  handleClick(e) {
    this.handlePanelDisplay(e.currentTarget);
  }

  handleKeyDown(e) {
    switch (e.keyCode) {
    case KEYS.END:
      e.preventDefault();
      this.focusTrigger(this.dom.$triggers[this.dom.$triggers.length - 1]);
      break;
    case KEYS.HOME:
      e.preventDefault();
      this.focusTrigger(this.don.$triggers[0]);
      break;
    case KEYS.UP:
    case KEYS.DOWN:
      e.preventDefault();
      break
    }
  }

  handleKeyUp(e) {
    switch (e.keyCode) {
    case KEYS.UP:
    case KEYS.DOWN:
      this.handleArrowPress(e);
      break;
    }
  }

  handlePanelDisplay($el) {
    const isExpanded = $el.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      this.collapse($el);
    } else {
      this.expand($el);
    }

    this.resetFocusability();
    const event = new CustomEvent('change');
    this.el.dispatchEvent(event);
  }

  handleArrowPress(e) {
    const $el = e.currentTarget;

    if (!KEYS_DIRECTION[e.keyCode]) return;
    if (typeof $el.dataset.index === 'undefined') return;
    const index = parseInt($el.dataset.index, 10);

    if (this.dom.$triggers[index + KEYS_DIRECTION[e.keyCode]]) {
      this.focusTrigger(this.dom.$triggers[index + KEYS_DIRECTION[e.keyCode]]);
      return;
    }

    if (e.keyCode === KEYS.UP) {
      this.focusTrigger(this.dom.$triggers[this.dom.$triggers.length - 1]);
    } else if (e.keyCode === KEYS.DOWN) {
      this.focusTrigger(this.dom.$triggers[0]);
    }
  }

  handleExpandAll(e) {
    e.target._$$('[aria-expanded]').forEach(this.expand.bind(this));
    this.resetFocusability();
    const event = new CustomEvent('change');
    this.el.dispatchEvent(event);
  }

  handleCollapseAll(e) {
    e.target._$$('[aria-expanded]').forEach(this.collapse.bind(this));
    this.resetFocusability();
    const event = new CustomEvent('change');
    this.el.dispatchEvent(event);
  }

  expand($el) {
    const panelId = $el.getAttribute('aria-controls');
    const $panel = this.el.parentNode._$(`#${panelId}`);

    $el.setAttribute('aria-expanded', 'true');
    $panel.style.maxHeight = `${$panel.scrollHeight}px`;
    $panel.style.visibility = 'visible';
    $panel.removeAttribute('aria-hidden');
  }

  collapse($el) {
    const panelId = $el.getAttribute('aria-controls');
    const $panel = this.el.parentNode._$(`#${panelId}`);

    $el.setAttribute('aria-expanded', 'false');
    $panel.style.maxHeight = '0';
    $panel.style.visibility = 'hidden';
    $panel.setAttribute('aria-hidden', 'true');
  }

  focusTrigger($el) {
    $el.focus();
  }

  updateMinHeights() {
    const $exapnded = this.dom.$panels.filter(el => !el.getAttribute('aria-hidden'));
    $exapnded.forEach(el => {
      el.style.maxHeight = `${el.scrollHeight}px`;
    })
  }

  resetFocusability() {
    const $exapnded = [];
    const $collapsed = [];

    this.dom.$panels.forEach(el => {
      if (el.getAttribute('aria-hidden')) {
        $collapsed.push(el);
      } else {
        $exapnded.push(el);
      }
    });

    $exapnded.forEach(panel => {
      panel._$$('a').forEach(el => el.removeAttribute('tabindex'))
    });
    $collapsed.forEach(panel => {
      panel._$$('a').forEach(el => el.setAttribute('tabindex', '-1'));
    })
  }

  checkIfOpen() {
    const params = new URLSearchParams(window.location.search);
    const param = params.get('openAccordion');
    if (param) {
      this.dom.$triggers.forEach($trigger => {
        if ($trigger.getAttribute('id') === param) {
          this.expand($trigger);
          setTimeout(() => {
            $trigger.scrollIntoView();
          }, 1000);
        } else {
          this.collapse($trigger);
        }
      });
    }
  }
}

export default Module;
